import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=7c891da8&scoped=true&"
import script from "./footer-info.vue?vue&type=script&lang=js&"
export * from "./footer-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c891da8",
  null
  
)

/* custom blocks */
import block0 from "./footer-info.vue?vue&type=custom&index=0&blockType=body"
if (typeof block0 === 'function') block0(component)

export default component.exports